import * as XLSX from 'xlsx';
import { CodelistRecord } from 'features/codelist/domain/codelistRecordSchema';

const sanitizeCsvValue = (val: string) => (/^[=+\-@\t\r]/.test(val) ? `\t${val}` : val);

export const getDownloadableCsvUrl = (records: CodelistRecord[]) => {
	const keys = Object.keys(records[0]);
	const csvRows = [
		keys.join(','), // header row
		...records.map(record =>
			keys
				.map(key => {
					const raw = record[key as keyof CodelistRecord];
					const value = typeof raw === 'string' ? sanitizeCsvValue(raw) : raw;
					if (
						typeof value === 'string' &&
						(value.includes(',') || value.includes('"') || value.includes('\n'))
					) {
						return `"${value.replace(/"/g, '""')}"`;
					}
					return value ?? '';
				})
				.join(',')
		)
	];
	const csvContent = csvRows.join('\r\n');
	const blob = new Blob([csvContent], {
		type: 'text/csv;charset=utf-8;'
	});
	return URL.createObjectURL(blob);
};

export const downloadAsExcel = (args: { records: CodelistRecord[]; filename: string }) => {
	const workbook = XLSX.utils.book_new();
	const worksheet = XLSX.utils.json_to_sheet(args.records);
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
	XLSX.writeFile(workbook, args.filename);
};

export const downloadCsvFromUrl = (args: { url: string; filename: string }) => {
	const a = document.createElement('a');
	a.style.display = 'none';
	a.href = args.url;
	a.setAttribute('download', args.filename);
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	window.URL.revokeObjectURL(args.url);
};
